import { ADVANCED_FILTER, DEFAULT_STATE } from '../constants'
import { searchPageStore } from '../index'

/**
 * Sets the advanced filters array
 * @param {string[]} advancedFilters - Array of advanced filter strings
 */
export const setAdvancedFilters = (advancedFilters) => {
  searchPageStore.setState({ advancedFilters })
}

/**
 * Adds an advanced filter to the array
 * @param {string} filter - Advanced filter to add
 */
export const addAdvancedFilter = (filter) => {
  const state = searchPageStore.getState()
  const currentFilters = state.advancedFilters || []

  if (!currentFilters.includes(filter)) {
    searchPageStore.setState({ advancedFilters: [...currentFilters, filter] })
  }
}

/**
 * Removes an advanced filter from the array
 * @param {string} filter - Advanced filter to remove
 */
export const removeAdvancedFilter = (filter) => {
  const state = searchPageStore.getState()
  const currentFilters = state.advancedFilters || []

  searchPageStore.setState({
    advancedFilters: currentFilters.filter((f) => f !== filter),
  })
}

/**
 * Turns one personal filter on or off; the ones that are on combine as AND
 * @param {string} filter - One of: "wish_list_only", "liked_models_only"
 * @param {boolean} isOn - Whether the filter should be on
 */
export const togglePersonalFilter = (filter, isOn) => {
  const { personalFilters = [] } = searchPageStore.getState()
  const others = personalFilters.filter(f => f !== filter)

  searchPageStore.setState({ personalFilters: isOn ? [...others, filter] : others })
}

/**
 * Sets the purchase filters
 * @param {string|undefined} purchaseFilter - "purchased_models_only" or undefined
 */
export const setPurchaseFilter = (purchaseFilter) => {
  searchPageStore.setState({ purchaseFilter })
}

/**
 * Clears all more filters. CGT Standard shares advancedFilters but belongs to the Quality group,
 * so clearQualityContent owns it.
 */
export const clearMoreFilters = () => {
  const { advancedFilters = [] } = searchPageStore.getState()

  searchPageStore.setState({
    advancedFilters: advancedFilters.filter(filter => filter === ADVANCED_FILTER.CGT_STANDARD_ONLY),
    personalFilters: DEFAULT_STATE.personalFilters,
    purchaseFilter: DEFAULT_STATE.purchaseFilter,
  })
}
